import { Injectable, PLATFORM_ID, Inject } from "@angular/core";

import { Observable, of, Subject } from "rxjs";

import { MktContentStaticService } from './mkt-content-static.service';
import { MktContentStorageService } from './mkt-content-storage.service';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from '@citi-gcg-173875/citi-http';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { MktEnvironmentService } from './mkt-environment.service';
import { mergeMap } from 'rxjs/operators';
import { SingletonInjectorGuard } from '../guards/singletonguard';

@Injectable({
  providedIn: 'root'
})
export class MktContentService extends SingletonInjectorGuard {

  public microsite:Subject<boolean> = new Subject<boolean>();

  constructor(
    private _httpService: HttpService,
    private _appConfigService: AppConfigService,
    private _contentStaticService: MktContentStaticService,
    private _contentStorageService: MktContentStorageService,
    @Inject(PLATFORM_ID) private platformId: string,
    private _environmentService: MktEnvironmentService
  ) {
    super(MktContentService);
  }

  public get(appId: string, contentType: string, contentId: string, prop: string, placeholdersObj?: any) {
    return this._contentStorageService.get(appId, contentType, contentId, prop, placeholdersObj);
  }

  public makeApiCall(appId: string, contentType: string, contentId: string): Observable<Response> {

    let baseUrl: string = '';
    if (isPlatformBrowser(this.platformId)) {
      baseUrl = this._environmentService.getEnvironmentVar("apiServerUrlPlatformClient");
    } else {
      // Need to use private URL for when running on the server
      baseUrl = this._environmentService.getEnvironmentVar("apiServerUrlPlatformServer");
      // console.log("BASEURL" + baseUrl);
    }

    let url: string = baseUrl + "/content/subBusinessID/" + this._appConfigService.getBusinessId() + "/applicationID/" + appId + "/contentType/" + contentType + "/contentID/" + contentId;

    return this._httpService.get(url, { getStaticContent: false }).pipe(mergeMap(data => this.saveData(data, appId, contentType, contentId)));
  }

  public getStaticBundle(appId: string, options?: {}): Observable<any> {
    return this._contentStaticService.getStaticBundle(appId, options);
  }


  public getPageDef(appId: string, viewId: string): Observable<any> {
    return this._contentStaticService.getPageDef(appId, viewId);
  }

  public getStaticResource(path: string) {
    this._contentStaticService.getStaticResource(path);
  }

  private saveData(data: any, appId: string, contentType: string, contentId: string) {
    var returnObj: any = {}
    if (data && data["content"]) {
      this._contentStorageService.set(appId, data["content"][appId]);
      returnObj = this._contentStorageService.get(appId, contentType, contentId);
    }
    return of(returnObj);
  }
}
